module.exports = __webpack_public_path__ + "static/media/Chimera_Main.0fe5ddea.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Chimera_Main.webp
// module id = ./src/assets/Chimera_Main.webp
// module chunks = 0